(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tp-anadir"] && !Shopify.designMode) return;
  try {
    /*
   * Ventana rápida de Horizon: al agregar desde ahí Horizon no hace la animación
   * de la foto volando al carrito. Cuando la ventana se cierra después de agregar,
   * la hacemos desde el botón "Añadir" que la abrió (el carrito no se abre).
   */
  (() => {
    if (window.tpAnadirListo) return;
    window.tpAnadirListo = true;

    let origen = null;

    document.addEventListener(
      'click',
      (evento) => {
        const boton = evento.target instanceof Element ? evento.target.closest('[data-tp-elegir]') : null;
        if (boton) origen = boton;
      },
      true
    );

    const volar = (desde) => {
      const carrito = document.querySelector('.header-actions__cart-icon');
      const imagen = desde?.dataset.imagen;
      if (!carrito || !imagen || !desde.isConnected || !customElements.get('fly-to-cart')) return;
      const vuelo = document.createElement('fly-to-cart');
      vuelo.classList.add('fly-to-cart--main');
      vuelo.style.setProperty('background-image', `url(${imagen})`);
      vuelo.style.setProperty('--start-opacity', '0');
      vuelo.source = desde;
      vuelo.destination = carrito;
      document.body.appendChild(vuelo);
    };

    document.addEventListener('shopify:cart:lines-update', (evento) => {
      const desde = origen;
      const ventana = evento.target instanceof Element ? evento.target.closest('#quick-add-dialog') : null;
      if (!desde || !ventana || evento.action !== 'add') return;
      evento.promise
        ?.then(({ detail } = {}) => {
          if (detail?.didError) return;
          origen = null;
          const dialogo = ventana.querySelector('dialog');
          if (dialogo?.open) {
            dialogo.addEventListener('close', () => requestAnimationFrame(() => volar(desde)), { once: true });
          } else {
            volar(desde);
          }
        })
        .catch(() => {});
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
